import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {ChatTimelineThinkingMode} from "../types";
import {setThinkingMode} from "../../../redux/slices/chat";

interface ThinkingToggleProps {}

const ThinkingToggle: React.FC<ThinkingToggleProps> = () => {
  const dispatch = useDispatch();
  const {
    thinkingMode
  } = useSelector((state: any) => state.chatMessages);

  const isThinkingOn = thinkingMode === ChatTimelineThinkingMode.COMPACT

  const handleToggle = (e: React.ChangeEvent<HTMLElement>) => {
    e.stopPropagation();
    if(isThinkingOn) {
      dispatch(setThinkingMode(ChatTimelineThinkingMode.OFF));
    } else {
      dispatch(setThinkingMode(ChatTimelineThinkingMode.COMPACT));
    }
  }

  return (
    <label className="absolute flex right-0 top-0 z-10 items-center mb-5 cursor-pointer">
      <input
        type="checkbox"
        className="sr-only peer"
        checked={isThinkingOn}
        onChange={handleToggle}
      />
      <span className=" text-xs font-medium text-gray-800 dark:text-gray-500">
        {isThinkingOn ? 'Thinking On' : 'Thinking Off'}
      </span>
      <div className="relative ms-3 w-9 h-5 bg-gray-200 peer-focus:outline-none   rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"></div>

    </label>
  );
};

export default ThinkingToggle;